import TextFieldMui from 'src/components/TextFieldMui'
import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const Wrapper = styled.form`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
`

export const ButtonsContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
`

export const CustomTextFieldMui = styled(TextFieldMui)`
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
`

export const CustomSelectMui = styled(SelectMui)`
    margin: 0 !important;
    padding: 0 !important;
    p {
        background: transparent !important
    }
`
